var termsOfService = {
  title: 'Servicevilkår',
  lastUpdated: '2. april 2026',
  sections: [
    {
      heading: '1. Accept af vilkår',
      paragraphs: [
        'Ved at tilgå eller bruge AlleFlow ("Tjenesten"), drevet af AlleFlow ("vi", "os" eller "vores"), accepterer du at være bundet af disse Servicevilkår. Hvis du ikke accepterer disse vilkår, bedes du undlade at bruge Tjenesten.'
      ]
    },
    {
      heading: '2. Beskrivelse af Tjenesten',
      paragraphs: [
        'AlleFlow er en workflow-automatiseringsplatform, der giver brugere mulighed for at forbinde tredjepartstjenester og opbygge automatiserede workflows gennem en visuel, knudebaseret grænseflade. Tjenesten kan integrere med tredjepartsplatforme, herunder men ikke begrænset til Google, TikTok og andre API\'er.'
      ]
    },
    {
      heading: '3. Brugerkonti',
      paragraphs: [
        'Du skal oprette en konto for at bruge Tjenesten. Du er ansvarlig for at opretholde fortroligheden af dine kontooplysninger og for alle aktiviteter, der finder sted under din konto. Du accepterer at give nøjagtige og fuldstændige oplysninger ved oprettelse af din konto.'
      ]
    },
    {
      heading: '4. Acceptabel brug',
      paragraphs: [
        'Du accepterer ikke at bruge Tjenesten til at:'
      ],
      list: [
        'Overtræde gældende love eller regler',
        'Krænke andres rettigheder',
        'Distribuere spam, malware eller skadeligt indhold',
        'Forsøge at få uautoriseret adgang til andre systemer eller netværk',
        'Misbruge eller overbelaste Tjenesten eller forbundne tredjeparts-API\'er',
        'Automatisere handlinger, der overtræder tredjepartsplatformes servicevilkår'
      ]
    },
    {
      heading: '5. Tredjepartsintegrationer',
      paragraphs: [
        'Tjenesten giver dig mulighed for at forbinde tredjepartskonti (f.eks. Google, TikTok). Ved at forbinde disse konti autoriserer du AlleFlow til at tilgå og interagere med disse tjenester på dine vegne inden for omfanget af de tilladelser, du giver. Vi er ikke ansvarlige for tilgængeligheden, nøjagtigheden eller politikkerne for tredjepartstjenester.',
        'Din brug af tredjepartstjenester gennem AlleFlow er også underlagt disse tjenesters egne vilkår og politikker.'
      ]
    },
    {
      heading: '6. Intellektuel ejendom',
      paragraphs: [
        'Tjenesten, herunder dens design, funktioner og indhold, ejes af AlleFlow og er beskyttet af lovgivning om intellektuel ejendom. Workflows og tilpassede konfigurationer, du opretter, forbliver dine, men du giver os en begrænset licens til at hoste og behandle dem efter behov for at levere Tjenesten.'
      ]
    },
    {
      heading: '7. Fraskrivelse af garantier',
      paragraphs: [
        'Tjenesten leveres "som den er" og "som tilgængelig" uden garantier af nogen art, hverken udtrykkelige eller underforståede. Vi garanterer ikke, at Tjenesten vil være uafbrudt, fejlfri eller sikker. AlleFlow er i øjeblikket i beta, og funktioner kan ændres uden varsel.'
      ]
    },
    {
      heading: '8. Ansvarsbegrænsning',
      paragraphs: [
        'I det omfang loven tillader det, skal AlleFlow ikke holdes ansvarlig for indirekte, tilfældige, særlige, følgeskader eller strafskader, der opstår som følge af eller i forbindelse med din brug af Tjenesten, herunder tab af data, omsætning eller forretningsmuligheder.'
      ]
    },
    {
      heading: '9. Opsigelse',
      paragraphs: [
        'Vi kan suspendere eller opsige din adgang til Tjenesten til enhver tid, med eller uden årsag eller varsel. Ved opsigelse ophører din ret til at bruge Tjenesten øjeblikkeligt. Du kan slette din konto til enhver tid.'
      ]
    },
    {
      heading: '10. Ændringer af vilkår',
      paragraphs: [
        'Vi kan opdatere disse Vilkår fra tid til anden. Fortsat brug af Tjenesten efter ændringer udgør accept af de opdaterede Vilkår. Vi opfordrer dig til at gennemgå denne side regelmæssigt.'
      ]
    },
    {
      heading: '11. Kontakt',
      paragraphs: [
        'Hvis du har spørgsmål om disse Vilkår, bedes du kontakte os på support@alleflow.xyz.'
      ]
    }
  ]
};

var privacyPolicy = {
  title: 'Privatlivspolitik',
  lastUpdated: '2. april 2026',
  sections: [
    {
      heading: '1. Introduktion',
      paragraphs: [
        'AlleFlow ("vi", "os" eller "vores") respekterer dit privatliv. Denne Privatlivspolitik forklarer, hvordan vi indsamler, bruger, opbevarer og beskytter dine personlige oplysninger, når du bruger vores workflow-automatiseringsplatform ("Tjenesten").'
      ]
    },
    {
      heading: '2. Oplysninger vi indsamler',
      paragraphs: [
        'Vi indsamler følgende typer oplysninger:'
      ],
      list: [
        'Kontooplysninger: e-mailadresse, navn og adgangskode, når du registrerer dig',
        'OAuth-tokens: når du forbinder tredjepartskonti (f.eks. Google, TikTok), gemmer vi adgangs- og opdateringstokens for at interagere med disse tjenester på dine vegne',
        'Workflow-data: de workflows, konfigurationer og tilpassede knuder, du opretter inden for Tjenesten',
        'Brugsdata: grundlæggende analyser som login-tidsstempler og funktionsbrug for at forbedre Tjenesten',
        'Enheds- og browseroplysninger: IP-adresse, browsertype og operativsystem til sikkerhed og fejlfinding'
      ]
    },
    {
      heading: '3. Hvordan vi bruger dine oplysninger',
      paragraphs: [
        'Vi bruger dine oplysninger til at:'
      ],
      list: [
        'Levere, vedligeholde og forbedre Tjenesten',
        'Autentificere din identitet og administrere din konto',
        'Udføre workflows og forbinde til tredjepartstjenester, du autoriserer',
        'Kommunikere med dig om opdateringer, sikkerhedsadvarsler eller support',
        'Opdage og forhindre svindel, misbrug eller sikkerhedshændelser'
      ]
    },
    {
      heading: '4. Tredjepartstjenester',
      paragraphs: [
        'Når du forbinder tredjepartskonti (som Google eller TikTok), tilgår vi kun de data og tilladelser, du udtrykkeligt autoriserer. Vi opbevarer OAuth-tokens sikkert og deler ikke dine tredjepartsdata med andre brugere eller eksterne parter.',
        'Hver tredjepartstjeneste har sin egen privatlivspolitik. Vi opfordrer dig til at gennemgå deres politikker, før du forbinder dine konti.'
      ]
    },
    {
      heading: '5. Dataopbevaring og sikkerhed',
      paragraphs: [
        'Dine data opbevares på sikre servere. Vi implementerer branchestandarder for sikkerhedsforanstaltninger, herunder kryptering under transport og i hvile, adgangskontroller og regelmæssige sikkerhedsgennemgange. Intet system er dog fuldstændigt sikkert, og vi kan ikke garantere absolut sikkerhed.'
      ]
    },
    {
      heading: '6. Datadeling',
      paragraphs: [
        'Vi sælger ikke dine personlige oplysninger. Vi kan dele dine data kun under følgende omstændigheder:'
      ],
      list: [
        'Med dit udtrykkelige samtykke',
        'For at overholde juridiske forpligtelser eller reagere på lovlige anmodninger',
        'For at beskytte AlleFlows eller vores brugeres rettigheder, sikkerhed eller ejendom',
        'Med tjenesteudbydere, der hjælper med at drive Tjenesten (under strenge fortrolighedsaftaler)'
      ]
    },
    {
      heading: '7. Dataopbevaring',
      paragraphs: [
        'Vi opbevarer dine data, så længe din konto er aktiv, eller så længe det er nødvendigt for at levere Tjenesten. Du kan til enhver tid anmode om sletning af din konto og tilknyttede data ved at kontakte os.'
      ]
    },
    {
      heading: '8. Dine rettigheder',
      paragraphs: [
        'Afhængigt af din jurisdiktion kan du have ret til at:'
      ],
      list: [
        'Få adgang til de personlige data, vi har om dig',
        'Anmode om rettelse eller sletning af dine data',
        'Gøre indsigelse mod eller begrænse behandlingen af dine data',
        'Anmode om en kopi af dine data i et portabelt format',
        'Trække samtykke til valgfri databehandling tilbage'
      ]
    },
    {
      heading: '9. Cookies',
      paragraphs: [
        'Vi bruger essentielle cookies og lokal lagring til at opretholde din session og dine præferencer. Vi bruger ikke tredjeparts sporingscookies til reklameformål.'
      ]
    },
    {
      heading: '10. Børns privatliv',
      paragraphs: [
        'Tjenesten er ikke beregnet til brugere under 13 år. Vi indsamler ikke bevidst personlige oplysninger fra børn. Hvis vi opdager, at vi har indsamlet data fra et barn, vil vi slette dem omgående.'
      ]
    },
    {
      heading: '11. Ændringer af denne politik',
      paragraphs: [
        'Vi kan opdatere denne Privatlivspolitik fra tid til anden. Vi vil underrette dig om væsentlige ændringer ved at offentliggøre den opdaterede politik på denne side med en revideret dato.'
      ]
    },
    {
      heading: '12. Kontakt',
      paragraphs: [
        'Hvis du har spørgsmål eller bekymringer vedrørende denne Privatlivspolitik, bedes du kontakte os på support@alleflow.xyz.'
      ]
    }
  ]
};

module.exports = { termsOfService: termsOfService, privacyPolicy: privacyPolicy };
